import controller from './controllers/search.controller';
import template from './templates/search.template.html';
import './styles/search.style.scss';

import input from './components/input';
import line from './components/result-line';

const component = {
	bindings: {
		config: '=',
		configMenu: '=?'
	},
	template,
	controller,
	controllerAs: 'vm'
};

angular.module('mb.topbar.search', [])
	.component('mbTSearch', component)
	.component('mbTSearchInput', input)
	.component('mbTResultLine', line);



// WEBPACK FOOTER //
// ./src/modules/topbar/components/search/index.js